<template>
  <div id="assist-networks" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-4" v-if="season_dropdown.data != undefined && $route.params.type == 'team'">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>

      <div class="col-md-1" v-if="team_dropdown.data != undefined && $route.params.type == 'team'">
        <team-select v-model="team_selected" :options="team_dropdown" :preselectFirst="true" :allowEmpty="false"></team-select>
      </div>
    </div>

    <div v-if="$route.params.type == 'team'" class="border-padding">
      <button class="" v-on:click="changeStats()">Get Stats</button>
    </div>

    <div class="text-description">
      <li>Mouseover nodes and links for more detail</li>
      <li>Click and drag node to lock it in place</li>
      <li>Double click node to show only connecting links</li>
      <li>Double click again to restore all links</li>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <svg width="960" height="600"></svg>

    <div v-if="assist_table_data.length > 0">
      <vue-good-table
        :columns="assist_table_columns"
        :rows="assist_table_data"
        :pagination-options="{ enabled: false }"
        :searchOptions="{ enabled: false }"
        :sort-options="{ enabled: false }"
        styleClass="vgt-table bordered striped">
      </vue-good-table>
      <p>Points from assists in brackets</p>
    </div>
  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import TeamSelect from './mixins/TeamSelect.vue'
import { season, seasonType } from './mixins/dropdowns'
const d3 = require('d3')

export default {
  name: 'AssistNetworks',
  components: {
    Multiselect,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect
  },
  mixins: [SeasonTypeSelect, SeasonSelect, TeamSelect, GetDropdownOptions, season, seasonType],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      seasons_selected: [],
      season_type_dropdown: {},
      season_type_selected: undefined,
      season_selected_string: '',
      team_dropdown: {},
      team_selected: undefined,
      nodes: [],
      links: [],
      node_radius: 15,
      assist_table_data: [],
      assist_table_columns: [],
      show_error_message: false,
      api_endpoint: 'get-assist-networks/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      d3.selectAll('svg > *').remove()
      this.nodes = []
      this.links = []
      this.seasons_selected = []
      this.season_selected_string = ''
      this.assist_table_data = []
      this.assist_table_columns = []
      this.$router.push({name: 'assist_networks', params: {league: this.$parent.league}})
    },
    checkIfStatsShouldBeLoaded () {
      if (this.$route.query.Season && this.$route.query.SeasonType) {
        this.getStats()
      }
    },
    loadData () {
      if (this.$route.params.type === 'team') {
        this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setTeamDropdown, this.checkIfStatsShouldBeLoaded])
      } else if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.LineupId && this.$route.params.type === 'lineup') {
        this.team_dropdown = {}
        this.team_selected = undefined
        this.getStats()
      } else if (this.$route.query.GameId && this.$route.params.type === 'game') {
        this.team_dropdown = {}
        this.team_selected = undefined
        this.getStats()
      } else {
        this.team_dropdown = {}
        this.team_selected = undefined
      }
    },
    updateData () {
      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.TeamId && this.$route.params.type === 'team') {
        this.getStats()
      } else if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.LineupId && this.$route.params.type === 'lineup') {
        this.getStats()
      } else if (this.$route.query.GameId && this.$route.query.TeamId && this.$route.params.type === 'game') {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changeStats () {
      var params = {}

      this.season_selected_string = this.getSeasonsSelectedString()
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id

      if (this.team_selected) {
        params[this.$teamIdParam] = this.team_selected.id
      }

      this.$router.push({name: 'assist_networks', query: params})
    },
    getStats () {
      this.show_error_message = false
      this.nodes = []
      this.links = []

      var params = {}
      if (this.$route.params.type === 'team') {
        params[this.$seasonParam] = this.$route.query.Season
        params[this.$seasonTypeParam] = this.$route.query.SeasonType
        params[this.$entityIdParam] = this.$route.query.TeamId
        params[this.$entityTypeParam] = 'Team'
      } else if (this.$route.params.type === 'lineup') {
        params[this.$seasonParam] = this.$route.query.Season
        params[this.$seasonTypeParam] = this.$route.query.SeasonType
        params[this.$entityIdParam] = this.$route.query.LineupId
        params[this.$entityTypeParam] = 'Lineup'
      } else if (this.$route.params.type === 'game') {
        params[this.$gameIdParam] = this.$route.query.GameId
        params[this.$entityIdParam] = this.$route.query.TeamId
        params[this.$entityTypeParam] = 'Team'
      }

      this.loading = true
      axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
        params: params
      })
        .then((response) => {
          if (!response.data.error) {
            this.nodes = response.data.results.nodes
            this.links = response.data.results.links
            this.addAssistNetwork()
            this.formatAssistNetworkTableData()
          } else {
            this.show_error_message = true
          }
          this.loading = false
        }, (error) => {
          this.show_error_message = true
          this.loading = false
          this.error = error
        })
    },
    addAssistNetwork () {
      d3.selectAll('svg > *').remove()
      var colors = d3.scaleOrdinal(d3.schemeCategory10)

      // Define the div for the tooltip
      var div = d3.select('body').append('div')
        .attr('class', 'tooltip')
        .style('opacity', 0)

      var svg = d3.select('svg')
      this.width = +svg.attr('width')
      this.height = +svg.attr('height')

      const nodeRadius = this.node_radius
      this.showAll = true

      this.maxAssistsValue = d3.max([d3.max(this.links, function (d) { return d.value })])

      var linearScale = d3.scaleLinear()
        .domain([0, this.maxAssistsValue])
        .range([0, 10])

      svg.append('defs').append('marker')
        .attr('id', 'arrowhead')
        .attr('viewBox', '0 -5 10 10')
        .attr('refX', 20)
        .attr('refY', 0)
        .attr('markerWidth', 10)
        .attr('markerHeight', 10)
        .attr('orient', 'auto')
        .attr('markerUnits', 'userSpaceOnUse')
        .append('path')
        .attr('d', 'M0,-5L10,0L0,5')

      this.simulation = d3.forceSimulation()
        .force('link', d3.forceLink().id(function (d) { return d.id }).distance(225).strength(1))
        .force('charge', d3.forceManyBody().strength(-1000))
        .force('center', d3.forceCenter(this.width / 2, this.height / 2))

      this.link = svg.selectAll('.link')
        .data(this.links)
        .enter()
        .append('path')
        .attr('class', 'link')
        .attr('stroke-width', function (d) { return linearScale(d.value) })
        .attr('marker-end', 'url(#arrowhead)')

      this.edgepaths = svg.selectAll('.edgepath')
        .data(this.links)
        .enter()
        .append('path')
        .attr('class', 'edgepath')
        .attr('id', function (d, i) { return 'edgepath' + i })
        .style('pointer-events', 'none')

      this.nodeDrag = d3.drag()
        .on('start', this.dragstarted)
        .on('drag', this.dragged)
        .on('end', this.dragended)

      this.node = svg.selectAll('.node')
        .data(this.nodes)
        .enter()
        .append('g')
        .attr('class', 'node')

      this.node.append('circle')
        .attr('r', function (d) { d.radius = nodeRadius; return d.radius })
        .style('fill', function (d, i) { return colors(i) })
        .on('dblclick', this.showOrHideLinks)
        .call(this.nodeDrag)

      this.node.append('text')
        .attr('dy', -1 * nodeRadius)
        .text(function (d) { return d.name })

      this.node.append('label')
        .attr('dy', -1 * nodeRadius)
        .text(function (d) { return d.name })

      this.simulation.nodes(this.nodes)
        .on('tick', this.ticked)

      this.simulation.force('link')
        .links(this.links)

      // mouseover tooltips
      this.node.on('mouseover', function (d) {
        var hoverHtml = '<b>' + d.name + '</b><br/>'
        if (d.assists_to.length > 0) {
          var assistsToText = '<b>Assists To:</b><br/>'
          d.assists_to.forEach(function (element) {
            assistsToText += '<li>' + element.name + ': ' + element.count + '</li>'
          })
          hoverHtml += assistsToText
        } else {
          hoverHtml += '<b>Assists To:</b><br/>None<br/>'
        }
        if (d.assists_from.length > 0) {
          var assistsFromText = '<b>Assists From:</b><br/>'
          d.assists_from.forEach(function (element) {
            assistsFromText += '<li>' + element.name + ': ' + element.count + '</li>'
          })
          hoverHtml += assistsFromText
        } else {
          hoverHtml += '<b>Assists From:</b><br/>None<br/>'
        }

        div.transition()
          .duration(200)
          .style('opacity', 0.9)
        div.html(hoverHtml)
          .style('left', (d3.event.pageX) + 'px')
          .style('top', (d3.event.pageY - 28) + 'px')
      })
      this.node.on('mouseout', function (d) {
        div.transition()
          .duration(500)
          .style('opacity', 0)
      })

      this.link.on('mouseover', function (d) {
        div.transition()
          .duration(200)
          .style('opacity', 0.9)
        var assists3 = d['Corner3'] + d['Arc3']
        var hoverHtml = d.source.name + ' to ' + d.target.name + '<br/><b>At Rim:</b> ' + d['AtRim'] + '<br/> <b>3pt:</b> ' + assists3 + '<br/> <b>Assist Pts:</b> ' + d['AssistPts']
        div.html(hoverHtml)
          .style('left', (d3.event.pageX) + 'px')
          .style('top', (d3.event.pageY - 28) + 'px')
      })
      this.link.on('mouseout', function (d) {
        div.transition()
          .duration(500)
          .style('opacity', 0)
      })
    },
    ticked () {
      const nodeRadius = this.node_radius
      const width = this.width
      const height = this.height
      this.link.attr('d', function (d) {
        // Total difference in x and y from source to target
        var diffX = d.target.x - d.source.x
        var diffY = d.target.y - d.source.y

        // Length of path from center of source node to center of target node
        var pathLength = Math.sqrt((diffX * diffX) + (diffY * diffY))

        // x and y distances from center to outside edge of target node
        var offsetX = (diffX * d.target.radius) / pathLength
        var offsetY = (diffY * d.target.radius) / pathLength

        return 'M' + d.source.x + ',' + d.source.y + 'A' + pathLength + ',' + pathLength + ' 0 0,1 ' + (d.target.x - offsetX) + ',' + (d.target.y - offsetY)
      })

      this.node.attr('transform', function (d) {
        // keep nodes contained in svg area
        d.x = Math.max(nodeRadius, Math.min(width - nodeRadius, d.x))
        d.y = Math.max(nodeRadius, Math.min(height - nodeRadius, d.y))
        return 'translate(' + d.x + ',' + d.y + ')'
      })

      this.edgepaths.attr('d', function (d) {
        return 'M ' + d.source.x + ' ' + d.source.y + ' L ' + d.target.x + ' ' + d.target.y
      })
    },
    dragstarted (d) {
      if (!d3.event.active) this.simulation.alphaTarget(0.05).restart()
      d.fx = d.x
      d.fy = d.y
    },
    dragged (d) {
      d.fx = d3.event.x
      d.fy = d3.event.y
    },
    dragended (d) {
      if (!d3.event.active) this.simulation.alphaTarget(0)
    },
    showOrHideLinks (clickedNode) {
      var clickedNodeId = clickedNode.id
      if (this.showAll) {
        this.link.filter(function (d) { return (d.source.id !== clickedNodeId && d.target.id !== clickedNodeId) })
          .style('visibility', 'hidden')
        this.showAll = false
      } else {
        this.link.style('visibility', 'visible')
        this.showAll = true
      }
    },
    formatAssistNetworkTableData () {
      var assistNetworkData = {}
      var columns = [{'field': 'name', 'label': '↓ From. To→ '}]
      this.nodes.forEach((element) => {
        assistNetworkData[element.id] = {}
        assistNetworkData[element.id]['name'] = element.name
        this.nodes.forEach((assistPlayerElement) => {
          assistNetworkData[element.id][assistPlayerElement.id] = '-'
        })
      })

      this.links.forEach((element) => {
        var assists = element['AtRim'] + element['ShortMidRange'] + element['LongMidRange'] + element['Corner3'] + element['Arc3']
        assistNetworkData[element.source.id][element.target.id] = assists + ' (' + element.AssistPts + ')'
      })
      Object.keys(assistNetworkData).forEach((playerId) => {
        var nameColumn = {'field': playerId, 'label': assistNetworkData[playerId]['name']}
        columns.push(nameColumn)
      })
      this.assist_table_columns = columns
      this.assist_table_data = Object.values(assistNetworkData)
    }
  }
}
</script>

<style>
.link {
  stroke: #999;
  fill: none;
}

div.tooltip {
    position: absolute;
    text-align: left;
    padding: 2px;
    font: 14px sans-serif;
    background: lightsteelblue;
    border: 2px;
    border-radius: 8px;
    pointer-events: none;
}

.tooltip li {
  list-style-type: none;
}

.text-description {
  float: left;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/AssistNetworks.vue